import React, { useContext, useState, useRef, useEffect } from "react";
import useGlobal from "../../context/GlobalContext";
import { navigate } from "gatsby";
import CurrencyContext from "../../context/CurrencyContext";

const currencyLanguageMap = {
  INR: "en-in",
  USD: "en-us",
  GBP: "en-uk",
};

const CurrencyToggle = () => {
  const { pageContext } = useGlobal();
  const { defaultValue, chooseMe } = useContext(CurrencyContext);
  const options = ["INR", "USD", "GBP"];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);
  const closeDropdown = () => setDropdownOpen(false);

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const updateCurrencyChange = (selected) => {
    const newCurrency = typeof selected === "string" ? selected : selected.value;
    chooseMe({ value: newCurrency });

    const newLang = currencyLanguageMap[newCurrency];
    if (newLang) {
      if (newLang === "en-in") {
        navigate(pageContext.url);
      } else {
        navigate(`/${newLang}${pageContext.url}`);
      }
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
    closeDropdown();
  };

  return (
    <li className="nav-item dropdown" ref={dropdownRef}>
      <a
        className="nav-link dropdown-toggle"
        role="button"
        onClick={toggleDropdown}
        aria-expanded={dropdownOpen}
        href="#"
        title="Select Currency"
      >
        {defaultValue || "Select an option"}
        <i className="me-1 bi bi-chevron-down"></i>
      </a>
      {dropdownOpen && (
        <ul className="dropdown-menu show">
          {options.map((option, index) => (
            <li key={index}>
              <button
                className="dropdown-item"
                onClick={() => updateCurrencyChange(option)}
              >
                {option}
              </button>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default CurrencyToggle;
